import { useEffect, useState } from 'react';
import { DynamicForm } from './DynamicForm';
import './RappelFloatingCta.css';

export function RappelFloatingCta() {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > window.innerHeight * 0.6);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <button
        type="button"
        className={`rappel-cta ${visible ? 'rappel-cta--visible' : ''}`}
        onClick={() => setOpen(true)}
      >
        Être rappelé
      </button>

      {open && (
        <div className="rappel-cta__overlay" onClick={() => setOpen(false)}>
          <div className="rappel-cta__panel" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="rappel-cta__close" onClick={() => setOpen(false)} aria-label="Fermer">
              ×
            </button>
            <h2>Demander à être rappelé</h2>
            <DynamicForm type="rappel" onSuccess={() => setTimeout(() => setOpen(false), 2000)} />
          </div>
        </div>
      )}
    </>
  );
}
